import { useEffect, useState } from "react";

/**
 * Живой обратный отсчёт до момента `expiresAt` (ISO-строка).
 * Подсвечивается красным в последние 2 часа, обновляется раз в секунду.
 */
export default function Countdown({ expiresAt }: { expiresAt: string }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const ms = new Date(expiresAt).getTime() - now;

  if (ms <= 0) {
    return <span style={{ color: "#b00020", fontWeight: 600 }}>⏳ Бронь истекла</span>;
  }

  const totalMin = Math.floor(ms / 60000);
  const days = Math.floor(totalMin / 1440);
  const hours = Math.floor((totalMin % 1440) / 60);
  const mins = totalMin % 60;
  const secs = Math.floor((ms % 60000) / 1000);

  let text: string;
  if (days > 0) text = `${days} д ${hours} ч`;
  else if (hours > 0) text = `${hours} ч ${mins} мин`;
  else text = `${mins} мин ${secs} с`;

  const urgent = ms < 2 * 3600 * 1000; // меньше 2 часов

  return (
    <span style={{ color: urgent ? "#b00020" : "var(--accent)", fontWeight: 600 }}>
      ⏳ Осталось: {text}
    </span>
  );
}
